import { Box, Link, Typography } from "@mui/material";
import React from "react";
import MuiButton from "@mui/material/Button";
import useMediaQuery from "@mui/material/useMediaQuery";
import { styled } from "@mui/material/styles";
import { useTheme } from "@mui/material/styles";
import constants from "src/constants";
import { makeStyles } from "@material-ui/core";
import { useDispatch, useSelector } from "src/store";
import { Utils } from "src/utils/Utils";
import { useCookies } from "react-cookie";

const LearnMore = () => {
  const theme = useTheme();
  const classes = useStyles();
  const state = useSelector((state) => state.bkv);
  const [cookies] = useCookies();

  const Button = styled(MuiButton)((props) => ({
    borderRadius: "10vw",
    background: theme.palette.mustard.main,
    whiteSpace: "nowrap",
  }));
  return (
    <Box
      sx={{
        color: "#fff",
        display: "flex",
        alignItems: "center",
        jusifyContent: "center",
        flexDirection: "column",
        padding: { xs: "10% 0", sm: "10% 0", md: "8% 0", lg: "5% 0" },
        // height: "30%",
        margin: "10% 0 0 0",
        background:
          "linear-gradient(94deg, #FFD27D -4.14%, #00B49D 36.64%, #09507F 79.16%)",
      }}
    >
      <Typography
        fontSize={{ xs: "19.5px", sm: "4vw", md: "4vw", lg: "30px" }}
        mb="2%"
        sx={{
          color: theme.palette.white.main,
        }}
        variant="body2"
        align="center"
      >
        Upgrade your electricity provider
      </Typography>
      <Button
        className={classes.button}
        sx={{
          padding: {
            xs: "3% 15%",
            sm: "3% 15%",
            md: "3% 15%",
            lg: "20px 28px",
          },
          minWidth: { lg: "190px" },
        }}
      >
        <Typography
          fontSize={{ xs: "9px", md: "3vw", lg: "20px" }}
          sx={{ lineHeight: "21px", fontWeight: "1000" }}
        >
          <Link
            underline="none"
            href={Utils.getEnrollmentLink(
              //cookies.ref_promo,
              state.zipcode,
              "SEOEIQ0001",
              state.bluebonnet?.ProductId,
              state.bluebonnet?.Pricing?.[0].Terms
            )}
            color="inherit"
            target="_blank"
          >
            Choose Bluebonnet
          </Link>
        </Typography>
      </Button>
    </Box>
  );
};

export default LearnMore;

const useStyles = makeStyles((theme) => ({
  button: {
    transition: "all .1s ease-in-out",
    border: "3px solid #FFD27D",
    "&:hover": {
      // transform: "scale(1.05, 1.05)",
      animation: "$scale .2s ease-in-out",
      background: "transparent",
    },
  },
  "@keyframes scale": {
    "0%": {
      // transform: "scale(1.05, 1.05)",
      animation: "$scale .2s ease-in-out",
    },
    "50%": {
      transform: "scale(1.03, 1.03)",
    },
    "100%": {
      transform: "scale(1)",
    },
  },
}));
